import { Panel } from "primereact/panel";
import * as generic from "../../../../../components/Generico";
import { InformacionGeneralClientePj } from "../../../../../models/trust/clientepj/InformacionGeneralClientePj";
import { useForm } from "react-hook-form";
import { ClientePjService } from "../../../../../service/trust/ClientePjService";
import { CatalogoService } from "../../../../../service/CatalogoService";
import { InputComponent } from "../../../../../components/InputComponent";
import { useEffect, useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { BottomActionBar } from "../../../../../components/ui/BottomActionBar";
import { InputActividadEconomica } from "../../../../../components/ui/Formularios/InputActividadEconomica";

export const InfoGeneralCliente = ({ toast, id, permss, catalogos, handleNext, nuevoCliente, soloLectura }) => {
    const omodel = new InformacionGeneralClientePj();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue, clearErrors, getValues, trigger } = useForm({ defaultValues, shouldTrim: true, mode: 'onTouched' });
    const clientePjServicio = new ClientePjService();
    const catalogoService = new CatalogoService();
    const { inDrop, inText, inCalendar, inArea } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [ecuadorOficina, setEcuadorOficina] = useState(false);
    const [ciudadesOficina, setCiudadesOficina] = useState([]);
    const [ecuadorRep, setEcuadorRep] = useState(false);
    const [ciudadesRep, setCiudadesRep] = useState([]);
    const [esRucRep, setEsRucRep] = useState(false);
    const [esCedulaRep, setEsCedulaRep] = useState(false);
    const [esOtrosEntidad, setEsOtrosEntidad] = useState(false);
    const [tieneAnexos, setTieneAnexos] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const onSubmit = (data) => {
        setIsSaving(true);
        data.ec = catalogos?.ecuador;
        data.tipo_entidad_otros = catalogos?.tipo_entidad_otros;
        data.fecha = generic.dateToString(data.fecha);
        data.fecha_constitucion = generic.dateToString(data.fecha_constitucion);
        data.seccion = 'seccion1';
        const accion = id == null ? clientePjServicio.nuevoCliente(data) : clientePjServicio.editarCliente({ ...data, id });
        accion.then(res => {
            nuevoCliente(res.data);
            generic.funcSuccess(res, toast);
            handleNext();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const editFicha = () => {
        setIsLoading(true);
        clientePjServicio.consultarCliente(id ?? 0, { seccion: 'seccion1' }).then(res => {
            const cats = catalogos;
            const _cli = res.data.cliente;
            setTieneAnexos(res.data.tiene_anexos || false);

            if (!_cli) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }

            if (res.data.ciudades_oficina) setCiudadesOficina(res.data.ciudades_oficina);
            if (res.data.ciudades_representante) setCiudadesRep(res.data.ciudades_representante);

            setEcuadorOficina(_cli.pais_oficina?.cat_id === cats?.ecuador?.cat_id);
            setEcuadorRep(_cli.pais_residencia_rep?.cat_id === cats?.ecuador?.cat_id);

            setEsRucRep(_cli.tipo_identificacion_rep?.cat_id === cats?.ruc?.cat_id);
            setEsCedulaRep(_cli.tipo_identificacion_rep?.cat_id === cats?.cedula?.cat_id);
            setEsOtrosEntidad(_cli.tipo_entidad?.cat_id === cats?.tipo_entidad_otros?.cat_id);

            _cli.fecha = generic.stringToDate(_cli.fecha);
            _cli.fecha_constitucion = generic.stringToDate(_cli.fecha_constitucion);

            nuevoCliente({ id: _cli.id, nemonico: _cli.nemonico });
            reset(generic.renewValues(_cli, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangeTipoEntidad = (e) => {
        const siEsOtros = e.value?.cat_id === catalogos?.tipo_entidad_otros?.cat_id;
        setEsOtrosEntidad(siEsOtros);
        // Si cambia de opción y ya no es OTROS, limpiamos el campo de texto y sus errores
        if (!siEsOtros) {
            setValue('tipo_entidad_especificar', '');
            clearErrors('tipo_entidad_especificar');
        }
    }

    const onChangePaisOficina = (e) => {
        setEcuadorOficina(e.value?.cat_id === catalogos?.ecuador?.cat_id);
        setValue('provincia_oficina', null);
        setValue('ciudad_oficina', null);
        setValue('ciudad_oficina_txt', '');
        setCiudadesOficina([]);
        if (getValues('telefono')) {
            trigger('telefono');
        }
    }

    const onChangeProvinciaOficina = (e) => {
        setValue('ciudad_oficina', null);
        if (!e?.value) { setCiudadesOficina([]); return; }
        catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesOficina(res.data));
    }

    const onChangePaisRep = (e) => {
        setEcuadorRep(e.value?.cat_id === catalogos?.ecuador?.cat_id);
        setValue('provincia_residencia_rep', null);
        setValue('ciudad_residencia_rep', null);
        setValue('ciudad_residencia_rep_txt', '');
        setCiudadesRep([]);
        if (getValues('telefono_rep') || getValues('celular_rep')) {
            trigger(['telefono_rep', 'celular_rep']);
        }
    }

    const onChangeProvinciaRep = (e) => {
        setValue('ciudad_residencia_rep', null);
        if (!e?.value) { setCiudadesRep([]); return; }
        catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesRep(res.data));
    }

    const onChangeTipoIdRep = (e) => {
        setEsRucRep(JSON.stringify(e.value) === JSON.stringify(catalogos?.ruc));
        setEsCedulaRep(JSON.stringify(e.value) === JSON.stringify(catalogos?.cedula));
        clearErrors('identificacion_rep');
    }

    const tipoDocRep = esRucRep ? 'IDEN_RUC' : esCedulaRep ? 'IDEN_CEDULA' : null;
    const reglaValidacionRep = (val) => {
        if (!tipoDocRep) return true;
        return generic.validarIdentificacionEcuador(val, tipoDocRep) || `${esRucRep ? 'RUC' : 'Cédula'} incorrecto`;
    };

    // RUC de Empresa siempre se valida como RUC
    const reglaValidacionRucEmpresa = (val) => {
        return generic.validarIdentificacionEcuador(val, 'IDEN_RUC') || 'RUC incorrecto';
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
            <Panel header={generic.renderPanelHeader('A', 'INFORMACIÓN GENERAL', 'pi pi-building')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inCalendar('fecha', {}, 3)}
                    {inText('razon_social', { icon: 'pi pi-building' }, 5)}
                    {inText('nombre_comercial', { icon: 'pi pi-tags' }, 4)}
                    {inDrop('tipo_entidad', catalogos?.tipo_entidad, { lab: omodel.optionLabel, chn: onChangeTipoEntidad }, 4)}
                    {inText('ruc', { validate: reglaValidacionRucEmpresa, icon: 'pi pi-id-card' }, 4)}
                    {inCalendar('fecha_constitucion', {}, 4)}
                    {esOtrosEntidad && inText('tipo_entidad_especificar', { icon: 'pi pi-pencil' }, 12)}

                    <InputActividadEconomica name="actividad_economica" control={control} modelDef={omodel.model['actividad_economica']} disabled={soloLectura} col={12} />
                    {inDrop('pais_oficina', catalogos?.pais, {
                        lab: omodel.optionLabel,
                        chn: onChangePaisOficina,
                        ne: tieneAnexos ? true : undefined, helpText: tieneAnexos ? "Para modificar el país, primero debe eliminar los anexos guardados en la Sección 5." : null
                    }, 4)}
                    {ecuadorOficina ? (
                        <>
                            {inDrop('provincia_oficina', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaOficina }, 4)}
                            {inDrop('ciudad_oficina', ciudadesOficina, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('ciudad_oficina_txt', { icon: 'pi pi-map-marker' }, 8)
                    )}

                    {inArea('direccion_oficina', 2, 500, 12)}

                    {inText('telefono', { icon: 'pi pi-phone', validate: generic.validarTelefonoDinamico(getValues, 'pais_oficina') }, 6)}
                    {inText('email', { icon: 'pi pi-envelope', pattern: generic.VALIDACION_EMAIL }, 6)}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('B', 'TIPO DE VINCULACIÓN', 'pi pi-link')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inDrop('tipo_vinculacion', catalogos?.tipo_vinculacion, { lab: omodel.optionLabel }, 12)}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('C', 'REPRESENTANTE LEGAL O APODERADO', 'pi pi-user')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    {inText('apellido_paterno_rep', { icon: 'pi pi-user' }, 4)}
                    {inText('apellido_materno_rep', { icon: 'pi pi-user' }, 4)}
                    {inText('nombres_rep', { icon: 'pi pi-user' }, 4)}

                    {inDrop('tipo_identificacion_rep', catalogos?.tipo_identificacion, { lab: omodel.optionLabel, chn: onChangeTipoIdRep }, 6)}
                    {inText('identificacion_rep', { validate: reglaValidacionRep, icon: 'pi pi-id-card' }, 6)}

                    {inDrop('genero_rep', catalogos?.genero, { lab: omodel.optionLabel }, 4)}
                    {inDrop('estado_civil_rep', catalogos?.estado_civil, { lab: omodel.optionLabel }, 4)}
                    {inDrop('nacionalidad_rep', catalogos?.nacionalidad, { lab: omodel.optionLabel }, 4)}

                    {inDrop('pais_residencia_rep', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePaisRep }, 4)}
                    {ecuadorRep ? (
                        <>
                            {inDrop('provincia_residencia_rep', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaRep }, 4)}
                            {inDrop('ciudad_residencia_rep', ciudadesRep, { lab: omodel.optionLabel }, 4)}
                        </>
                    ) : (
                        inText('ciudad_residencia_rep_txt', { icon: 'pi pi-map-marker' }, 8)
                    )}
                    {inArea('direccion_residencia_rep', 2, 500, 12)}

                    {inText('telefono_rep', { icon: 'pi pi-phone', validate: generic.validarTelefonoDinamico(getValues, 'pais_residencia_rep') }, 4)}
                    {inText('celular_rep', { icon: 'pi pi-mobile', validate: generic.validarTelefonoDinamico(getValues, 'pais_residencia_rep') }, 4)}
                    {inText('email_rep', { icon: 'pi pi-envelope', pattern: generic.VALIDACION_EMAIL }, 4)}

                    <div className="col-12 mt-2 mb-2 border-top-1 border-300"></div>
                    {!ecuadorRep && inArea('direccion_extranjero_rep', 2, 500, 12)}
                </div>
            </Panel>

            <BottomActionBar layoutVersion="v2" onNext={handleNext} loading={isSaving} isReadOnly={soloLectura} />
        </form>
    );
}